export const ACTION_LABELS: Record<string, string> = {
  BLOCK: "Bloqueio",
  UNBLOCK: "Desbloqueio",
  PASSWORD_RESET: "Reset de Senha",
};

export const ACTION_COLORS: Record<string, string> = {
  BLOCK: "text-red-600 bg-red-50",
  UNBLOCK: "text-green-600 bg-green-50",
  PASSWORD_RESET: "text-yellow-600 bg-yellow-50",
};

export const getActionLabel = (action: string): string => {
  return ACTION_LABELS[action] || action;
};

export const getActionColor = (action: string): string => {
  return ACTION_COLORS[action] || "text-gray-600 bg-gray-50";
};
